import createApiServices from './createApiServices'
import {AUTH_URL} from "../ConfigUrlApi"

const api = createApiServices({baseUrl: AUTH_URL})

export const getTokenFromTicket = (payload) => {
    return api.makeRequest({
        url: '/auth/login',
        method: 'POST',
        data: payload
    })
}
